// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfDecade/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfDecade = convertToFP(fn, 1);
export default endOfDecade;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfDecade/index.js
// module id = 858
// module chunks = 0